// Shared so skeleton and real rows are exactly the same height (no jump on load).
export const ROW_HEIGHT = 64;

export const PAGE_SIZE = 50;

// Matches the API; shorter terms browse instead of filtering.
export const MIN_SEARCH_LENGTH = 2;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/constants.js
 **/